module.exports = "pegasus/assets/blocks/column-lp2-basic.png";